<figure class="sh-media-block">
  @if (!(processing || previewError)) {
    <div class="sh-contained-media sh-media-block__media" [ShDragData]="dragString">
      <img [src]="imgSrc" fetchpriority="low" loading="lazy" [alt]="imgAlt" class="sh-contained-media__media -sh-rounded" [attr.draggable]="dragString ? false : null" />
    </div>
  } @else {
    <sh-media-placeholder [spinning]="processing" [message]="previewMessage"></sh-media-placeholder>
  }
  <figcaption class="sh-media-block__caption">
    <ng-content></ng-content>
  </figcaption>
</figure>

